<div class="total">
  <span class="total-amount">{{ totalAmount() }}{{ amountSign() }}</span>
  <div class="total-legend">
    <span [innerHTML]="description()"></span>
    @if(tooltipText()){
    <button class="total-button"
            #tooltip="matTooltip"
            matTooltip="{{tooltipText()}}"
            (click)="tooltip.show()">
      <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.28073 4.53625C6.28073 4.39406 6.33721 4.25769 6.43775 4.15715C6.53829 4.05661 6.67465 4.00012 6.81683 4.00012C6.95901 4.00012 7.09537 4.05661 7.19591 4.15715C7.29645 4.25769 7.35293 4.39406 7.35293 4.53625C7.35293 4.67843 7.29645 4.8148 7.19591 4.91534C7.09537 5.01589 6.95901 5.07237 6.81683 5.07237C6.67465 5.07237 6.53829 5.01589 6.43775 4.91534C6.33721 4.8148 6.28073 4.67843 6.28073 4.53625ZM5.74463 6.14462C5.74463 5.94692 5.90434 5.7872 6.10203 5.7872H6.81683C7.01452 5.7872 7.17423 5.94692 7.17423 6.14462V8.64653H7.53163C7.72932 8.64653 7.88903 8.80625 7.88903 9.00395C7.88903 9.20164 7.72932 9.36136 7.53163 9.36136H6.10203C5.90434 9.36136 5.74463 9.20164 5.74463 9.00395C5.74463 8.80625 5.90434 8.64653 6.10203 8.64653H6.45943V6.50203H6.10203C5.90434 6.50203 5.74463 6.34231 5.74463 6.14462Z"
          fill="currentColor"/>
        <circle cx="6.68872" cy="6.6698" r="6.28302" stroke="currentColor" stroke-width="0.698113"/>
      </svg>
    </button>
    }
  </div>
</div>
